import { replayIntegration } from '@sentry/react';

import { blockList } from '../config';
import { currentStep, replaySplit } from '../helper/getConfigFromBackend';
import { activeSplits } from '../helper/getConfigFromBackend';

const doesSplitMatch = (splitFromConfig = '') => {
    const [split_id, split_variation] = splitFromConfig.split('_');

    return activeSplits?.some(
        (activeSplit) =>
            activeSplit.id === Number(split_id) &&
            activeSplit.variation === split_variation
    );
};

export const replay = replayIntegration({
    maskAllText: false,
    blockAllMedia: false,
    mask: blockList.maskCSSIdentifiers,
    mutationBreadcrumbLimit: 1000,
    mutationLimit: 1500,
    beforeErrorSampling: (error) =>
        blockList.blockUrlIdentifiers.some((ident) =>
            error?.request?.url?.includes(ident)
        ),
});

export const replaysSessionSampleRate = 0.0;

export const replaysOnErrorSampleRate =
    doesSplitMatch(replaySplit) &&
    `${process.env.C24_SENTRY_REPLAY_WHITELIST}`.includes(currentStep)
        ? 1
        : 0;
